import { configureStore } from "@reduxjs/toolkit";

//  slices
import appSlice from "../redux/slices/appSlice";
import helperModalsSlice from "./slices/helperModalsSlice";
import usersSlice from "./slices/users";

export const store = configureStore({
	reducer: {
		app: appSlice,
		helperModals: helperModalsSlice,
		users: usersSlice,
	},
});
